import React from 'react'
import { IconButton, Typography } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from 'src/auth/AuthProvider';

import './SignOutButton.scss'



const SignOutButton = () => {
    const auth = useAuth()
    const signOut = async () => {
        auth.signout()
    }

    return (
        <IconButton
            className="category-button signout-btn"
            onClick={signOut}
            title="Sign Out"
        >
            <LogoutIcon />
            <Typography variant="caption">Sign Out</Typography>
        </IconButton>
    )
}

export const SignOutApiButton = () => {
    return (
        <IconButton
            className="category-button signout-btn"
            href={'/signOut'}
            title="Sign Out"
        >
            <LogoutIcon />
            <Typography variant="caption">Sign Out</Typography>
        </IconButton>
    )
}


export default SignOutButton